import { alphaSort } from 'vet-bones/utils';

import {
  MappingField,
  ModelConceptAttributeData,
} from 'src/containers/ProjectDiagram/types/data';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { getAbbreviationOrFullIri } from 'src/utils/getAbbreviationOrFullIri';
import { getBindingAndVariableFunction } from 'src/utils/stringify/mappings/bindings';

export const mappingFieldSort = alphaSort((item: MappingField) => item.value);
export const attributeDataSort = alphaSort(
  (item: ModelConceptAttributeData) => item.value
);

export const stringifyLabel = (text: string) => text.replace(/\W/g, '_');

export const getMappingHelpers = (
  labelsByIri: Record<string, string>,
  dataNamespace: string,
  namespaces: Record<string, string>
) => {
  const abbreviate = (iri: string) => getAbbreviationOrFullIri(iri, namespaces);

  const getStringifiedLabel = (iri: string) =>
    stringifyLabel(getLabelForIri(labelsByIri, iri));

  const usedVariables: Record<string, number> = {};
  const getUniqueVariable = (variable: string) => {
    if (usedVariables[variable] === undefined) {
      usedVariables[variable] = 0;
      return variable;
    }

    usedVariables[variable] += 1;
    return `${variable}_${usedVariables[variable]}`;
  };

  const getBindingAndVariable = getBindingAndVariableFunction({
    dataNamespace,
    getStringifiedLabel,
    getUniqueVariable,
  });

  return {
    abbreviate,
    getBindingAndVariable,
    getStringifiedLabel,
    getUniqueVariable,
  };
};
